"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarketplaceReport = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const icons_material_1 = require("@mui/icons-material");
const x_data_grid_premium_1 = require("@mui/x-data-grid-premium");
const react_intl_1 = require("react-intl");
const mui_page_layout_1 = require("@dzambalaorg/mui-page-layout");
const react_hooks_1 = require("@dzambalaorg/react-hooks");
const provider_user_1 = require("@dzambalaorg/provider-user");
const ui_kit_1 = require("@dzambalaorg/ui-kit");
const report_data_view_1 = require("./report-data-view");
const search_1 = require("./search");
const schemas_1 = require("./schemas");
const MarketplaceReport = (props) => {
    const { service } = props;
    const { profile } = (0, provider_user_1.useUser)();
    const initialSearchValues = (0, react_1.useMemo)(() => {
        return (0, schemas_1.marketplaceReportSearchParams)(profile)[service];
    }, [profile]);
    const { isLoading, take, skip, onChangePage, allRows, totalCount } = (0, react_hooks_1.useFetchQuery)("/marketplace/report/search", void 0, void 0, initialSearchValues);
    const { formatMessage } = (0, react_intl_1.useIntl)();
    // TODO - [AFTER ALL REFACTORING] - check possibility to return search values from useFetchQuery
    // const { fn } = useApiCall(async (api, values) => {
    //   return api.fetchFile({
    //     url: "/ponzi/report/export",
    //     data: values,
    //   });
    // });
    const handleExport = () => {
        // return fn(void 0, search);
        return Promise.resolve();
    };
    const getDetailPanelContent = (0, react_1.useCallback)(({ row }) => (0, jsx_runtime_1.jsx)(report_data_view_1.MarketplaceReportDataView, { row: row }), []);
    const getDetailPanelHeight = (0, react_1.useCallback)(() => "auto", []);
    const columns = (0, schemas_1.marketplaceReportColumnsCreator)(formatMessage);
    return ((0, jsx_runtime_1.jsxs)(react_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(mui_page_layout_1.Breadcrumbs, { path: ["dashboard", "marketplace", "marketplace.report"] }), (0, jsx_runtime_1.jsx)(mui_page_layout_1.PageHeader, { message: "pages.marketplace.report.title", children: (0, jsx_runtime_1.jsx)(ui_kit_1.Button, { startIcon: (0, jsx_runtime_1.jsx)(icons_material_1.CloudDownload, {}), onClick: void handleExport, children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "form.buttons.export" }) }) }), (0, jsx_runtime_1.jsx)(search_1.MarketplaceReportSearchForm, { initialSearchValues: initialSearchValues, service: service }), (0, jsx_runtime_1.jsx)(x_data_grid_premium_1.DataGridPremium, { pagination: true, paginationMode: "server", rowCount: totalCount, paginationModel: { page: skip / take, pageSize: take }, onPaginationModelChange: ({ page }) => onChangePage({}, page), pageSizeOptions: [5, 10, 25], loading: isLoading, columns: columns, getDetailPanelHeight: getDetailPanelHeight, getDetailPanelContent: getDetailPanelContent, rows: allRows.map((event) => {
                    return {
                        id: event.id,
                        tokenId: event.items[0]?.token?.id,
                        title: event.items[0]?.token?.template?.title,
                        account: event.eventData.account,
                        eventData: event.eventData,
                        eventType: event.eventType,
                        price: event.price,
                        createdAt: event.createdAt,
                        items: event.items,
                    };
                }), getRowHeight: () => "auto", sx: {
                    [`& .${x_data_grid_premium_1.gridClasses.cell}`]: {
                        p: 1.5,
                    },
                }, disableAggregation: true, disableRowGrouping: true })] }));
};
exports.MarketplaceReport = MarketplaceReport;
//# sourceMappingURL=index.js.map